import React from 'react';
import { ThemeProvider } from 'styled-components';
import { themeColor } from './theme';

const theme = {
	color: themeColor,
	// fontSize: themeFontSize,
	// width: themeWidth,
	// height: themeHeight,
};

const StyledTheme = ({ children }) => <ThemeProvider theme={theme}>{children}</ThemeProvider>;

export default StyledTheme;
